module.exports = __webpack_public_path__ + "static/media/slider4.0a31f85b.jpg";